import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

import {
  mapQueries,
  useMapStore,
  useViewingRoomStore,
  useSearchFilterStore,
} from '@/entities/map'

export const useRoomsQuery = ({ enabled = true }: { enabled?: boolean }) => {
  const { zoomLevel, ...bounds } = useMapStore(state => state.params)
  const filters = useSearchFilterStore(state => state.filters)
  const canFetchRoom = useMapStore(state => state.canFetchRoom)
  const viewingRoom = useViewingRoomStore(state => state.viewingRoom)

  const mapParams = (() => {
    if (viewingRoom) {
      return {
        roomMarkerLat: viewingRoom.position.lat,
        roomMarkerLng: viewingRoom.position.lng,
        zoomLevel,
      }
    }

    return bounds
  })()

  const result = useInfiniteQuery({
    ...mapQueries.roomList({
      ...filters,
      ...mapParams,
      size: 10,
    }),
    enabled: enabled && canFetchRoom(),
    select: data => {
      return {
        rooms: data.pages.flatMap(page => page.content),
        isFirstPage: data.pages.length === 1,
      }
    },
    placeholderData: keepPreviousData,
  })

  if (!canFetchRoom()) {
    return {
      ...result,
      data: {
        rooms: null,
        isFirstPage: null,
      },
    }
  }

  return result
}
